import API from "@/api/forms2-4/FormAccreditationAPI";
import {idUserForApi} from "@/controllers/UserController";

export function spliceUslDataToArray(obj = {}) {
  return Object.values(obj).reduce((acc, arr) => {
    if (arr) acc.push(...arr);
    return acc;
  }, [])
}

class Form4AccreditationController {
  constructor() {
    this.api = API;
    this.mock = false
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  /**
   *
   * @param { Number | null | undefined } [orgId]
   * */
  async getData(orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const res = this.mock ? {data: []} : await this.api.read(orgId);
      return spliceUslDataToArray(res.data)
    } catch (e) {
      console.error('error getData ' + e.message)
      throw new Error('error getData ' + e.message)
    }
  }

  /**
   *@param { {
   * id: number,
   * kcpUgs: {id: number},
   * sprOrgId: number,
   * gasnm: boolean,
   * gadtb: string,
   * gadte: string || null,
   * gatxt: string,
   * gaypa: number
   * } } data
   * @param { Number | null | undefined } [orgId]
   * */
  async setData(data, orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const payload = {...data, org: {id: orgId}}
      let res;
      if (data.id)
        res = this.mock ? {data: {...payload}} : await this.api.update(payload)
      else
        res = this.mock ? {data: {...payload, id: Math.random()}} : await this.api.create(payload);
      return res.data
    } catch (e) {
      console.error('error setData ' + e.message)
      throw new Error('error setData ' + e.message)
    }
  }

  /**
   *
   * @param { Number} [id]
   * */
  async deleteRow(id) {
    try {
      this._checkId(id);
      const res = this.mock ? {data: {}} : await this.api.delete(id);
      return res.data
    } catch (e) {
      console.error('error deleteRow ' + e.message)
      throw new Error('error deleteRow ' + e.message)
    }
  }

}

export default new Form4AccreditationController()